import React, { useState, useEffect } from 'react'

import classes from './Star.module.css'
import clsx from 'clsx';

const Star = ({filled, inBar=false, hideBlackLine=false, intermediate=false, children}) => {
  return (
    <svg
      width="287"
      height="274"
      viewBox="45 35 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx(filled && classes.active)}

    >

      <path
        d="M128.331 55.5273C134.437 42.5687 153.052 42.5687 159.158 55.5273L159.444 56.1641L177.373 98.2666L223.659 102.255L224.353 102.328C238.535 104.091 244.475 121.73 233.862 131.58L233.336 132.051L198.382 162.127L208.797 206.808L208.944 207.499C211.701 221.73 196.445 232.39 184.001 225.564L183.401 225.221L143.745 201.478L104.089 225.221C91.3422 232.852 75.2428 221.612 78.6934 206.808L89.1064 162.126L54.1533 132.051C42.6447 122.148 48.9183 103.54 63.8301 102.255L110.115 98.2666L128.046 56.1641L128.331 55.5273Z"
        fill={ inBar ? "#426160" : "url(#paint0_radial_1139_4261)" }
        stroke={ inBar ? "#426160" : "url(#paint1_linear_1139_4261)" }
        strokeWidth="7.85021"
      />


      <g transform="scale(0.93) translate(12 12)">
        {filled && <path
          d="M131.877 57.6045C136.652 47.4725 151.379 47.6358 155.833 58.0947L174.067 100.914L174.144 101.076C174.549 101.87 175.353 102.426 176.292 102.507L223.322 106.559L223.856 106.614C234.792 107.973 239.329 121.543 231.181 129.106L230.776 129.468L195.209 160.071C194.469 160.708 194.157 161.683 194.372 162.604L204.974 208.092L205.087 208.621C207.2 219.534 195.489 227.782 185.881 222.512L185.418 222.246L145.135 198.129C144.335 197.65 143.342 197.62 142.518 198.039L142.354 198.129L102.072 222.246C92.2284 228.139 79.8704 219.443 82.5156 208.092L93.1182 162.604L93.1523 162.431C93.283 161.62 93.0148 160.787 92.4141 160.194L92.2812 160.071L56.7139 129.468C47.8786 121.866 52.6677 107.55 64.167 106.559L111.198 102.507L111.384 102.484C112.304 102.341 113.071 101.739 113.422 100.914L131.657 58.0947L131.877 57.6045Z"
          fill="url(#paint1_linear_895_8309)"
          className={classes.hide_if_inactive}
        />}
        {filled && <path
          d="M131.877 57.6045C136.652 47.4725 151.379 47.6358 155.833 58.0947L174.067 100.914L174.144 101.076C174.549 101.87 175.353 102.426 176.292 102.507L223.322 106.559L223.856 106.614C234.792 107.973 239.329 121.543 231.181 129.106L230.776 129.468L195.209 160.071C194.469 160.708 194.157 161.683 194.372 162.604L204.974 208.092L205.087 208.621C207.2 219.534 195.489 227.782 185.881 222.512L185.418 222.246L145.135 198.129C144.335 197.65 143.342 197.62 142.518 198.039L142.354 198.129L102.072 222.246C92.2284 228.139 79.8704 219.443 82.5156 208.092L93.1182 162.604L93.1523 162.431C93.283 161.62 93.0148 160.787 92.4141 160.194L92.2812 160.071L56.7139 129.468C47.8786 121.866 52.6677 107.55 64.167 106.559L111.198 102.507L111.384 102.484C112.304 102.341 113.071 101.739 113.422 100.914L131.657 58.0947L131.877 57.6045Z"
          fill="#FFC766"
          className={classes.hide_if_inactive}
        /> }
        {filled && !hideBlackLine && <path
          d="M131.877 57.6045C136.652 47.4725 151.379 47.6358 155.833 58.0947L174.067 100.914L174.144 101.076C174.549 101.87 175.353 102.426 176.292 102.507L223.322 106.559L223.856 106.614C234.792 107.973 239.329 121.543 231.181 129.106L230.776 129.468L195.209 160.071C194.469 160.708 194.157 161.683 194.372 162.604L204.974 208.092L205.087 208.621C207.2 219.534 195.489 227.782 185.881 222.512L185.418 222.246L145.135 198.129C144.335 197.65 143.342 197.62 142.518 198.039L142.354 198.129L102.072 222.246C92.2284 228.139 79.8704 219.443 82.5156 208.092L93.1182 162.604L93.1523 162.431C93.283 161.62 93.0148 160.787 92.4141 160.194L92.2812 160.071L56.7139 129.468C47.8786 121.866 52.6677 107.55 64.167 106.559L111.198 102.507L111.384 102.484C112.304 102.341 113.071 101.739 113.422 100.914L131.657 58.0947L131.877 57.6045Z"
          stroke="#082436"
          strokeWidth="10.4669"
          className={classes.hide_if_inactive}
        /> }
        { filled && <path
          d="M87.6127 209.279C86.0404 216.025 93.4102 221.332 99.384 217.756L104.594 214.637C104.603 214.595 104.612 214.554 104.621 214.513C84.8683 214.637 110.764 188.159 115.223 169.025C115.883 166.197 114.913 163.239 112.703 161.338L77.1359 130.734C71.8651 126.199 74.6756 117.605 81.6253 117.006L128.656 112.954C131.571 112.703 134.107 110.873 135.246 108.198L144.354 68.8248C145.288 64.786 150.105 63.0903 153.364 65.6534V65.6534L151.018 60.1451C148.301 53.7641 139.189 53.7641 136.472 60.1451L118.237 102.965C117.098 105.639 114.562 107.47 111.647 107.721L64.6165 111.773C57.6668 112.371 54.8563 120.966 60.1271 125.501L95.6942 156.104C97.904 158.006 98.8738 160.963 98.2147 163.791L87.6127 209.279Z"
          fill="#FFFFCC"
          className={classes.hide_if_inactive}
        /> }
        { filled && <path
          d="M175.8 107.694C177.019 110.13 190.099 115.334 192.852 115.571L230.097 121.432C231.406 114.236 225.892 112.033 222.873 111.773L175.8 107.694Z"
          fill="#FFFFCC"
          className={classes.hide_if_inactive}
        /> }
        { filled && <path
          d="M199.351 211.709C190.846 217.756 181.033 203.205 159.599 193.639C157.09 192.137 148.87 191.89 146.362 193.392L188.106 217.756C190.889 219.422 199.351 219.56 199.351 211.709Z"
          fill="#FFFFCC"
          className={classes.hide_if_inactive}
        /> }
      </g>
      { inBar && (!filled || !intermediate) &&<text x="72%" y="83%" className={clsx(classes.star_text, filled && classes.filled)} textAnchor="middle">{children}</text> }

      <defs>
        <radialGradient id="paint0_radial_1139_4261" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(125 160) rotate(13.7516) scale(110 110)">
          <stop stopColor="#30637F" />
          <stop offset="1" stopColor="#092437" />
        </radialGradient>
        <linearGradient id="paint1_linear_1139_4261" x1="106.97" y1="8.61444" x2="69.1188" y2="167.72" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4678A0" />
          <stop offset="1" stopColor="#7CA8D3" />
        </linearGradient>
        <linearGradient id="paint0_linear_895_8309" x1="143.745" y1="54.9668" x2="143.745" y2="218.513" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4678A0" />
          <stop offset="1" stopColor="#7CA8D3" />
        </linearGradient>
        <linearGradient id="paint1_linear_895_8309" x1="88.6746" y1="55.3594" x2="198.815" y2="218.905" gradientUnits="userSpaceOnUse">
          <stop offset="0.326539" stopColor="#FFE478" />
          <stop offset="0.896" stopColor="#FFAF47" />
        </linearGradient>
      </defs>
    </svg>
  )
}



export default Star;
